import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private requests = 0;

  constructor(private spinnerService: NgxSpinnerService) { }
  public llamarspinner() {
    this.requests++;
    // mostrar solo si es la primera petición
    if (this.requests === 1) {
      this.spinnerService.show();
    }
  }
  detenerspinner() {
    if (this.requests > 0) {
      this.requests--;
    }

    // ocultar solo si ya no quedan peticiones activas
    if (this.requests === 0) {
      this.spinnerService.hide();
    }

  }
}


